enum MARK_TYPES {
  LINK = 'link',
  BOLD = 'bold',
  ITALIC = 'italic',
  UNDERLINE = 'underline',
  STRIKE = 'strike',
}

export {MARK_TYPES};
